var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfigureComponentBase } from '../../../../../../../shared/configure-component-base';
import { finalize } from 'rxjs/operators';
import { EnumConditions } from './enum-conditions';
var ChooseAlarmModalComponent = /** @class */ (function (_super) {
    __extends(ChooseAlarmModalComponent, _super);
    function ChooseAlarmModalComponent(injector, fBoxAlarmRegistrationServiceProxy, dataTypeService, modalRef) {
        var _this = _super.call(this, injector) || this;
        _this.fBoxAlarmRegistrationServiceProxy = fBoxAlarmRegistrationServiceProxy;
        _this.dataTypeService = dataTypeService;
        _this.modalRef = modalRef;
        _this.fBoxAlarmSelected = new EventEmitter();
        return _this;
    }
    ChooseAlarmModalComponent.prototype.ngAfterViewInit = function () {
        this.getRefAlarmsAndGroup();
    };
    ChooseAlarmModalComponent.prototype.save = function () {
        this.saving = true;
        if (this.selectedFBoxAlarm) {
            this.fBoxAlarmSelected.emit(this.selectedFBoxAlarm);
        }
        this.saving = false;
        this.close();
    };
    ChooseAlarmModalComponent.prototype.close = function () {
        this.modalRef.hide();
    };
    ChooseAlarmModalComponent.prototype.formatConditionType = function (record) {
        var isBit = (record.dataType === 0 || record.bitIndexEnabled);
        if (isBit) {
            if (record.operand1 === 0) {
                return 'OFF';
            }
            if (record.operand1 === 1) {
                return 'ON';
            }
            return '';
        }
        switch (record.conditionCombineMethod) {
            case 0:
                return this.lc('Value') + ' ' + this.convertCondition(record.condition1) + record.operand1;
            case 1:
                return this.lc('Value') + ' ' + this.convertCondition(record.condition1) +
                    record.operand1 + this.lc('And') + this.convertCondition(record.condition2) + record.operand2;
            case 2:
                return this.lc('Value') + ' ' + this.convertCondition(record.condition1) +
                    record.operand1 + this.lc('Or') + this.convertCondition(record.condition2) + record.operand2;
        }
    };
    ChooseAlarmModalComponent.prototype.convertCondition = function (condition) {
        switch (condition) {
            case +EnumConditions.NotEqualTo:
                return this.lc('NotEqualTo');
            case +EnumConditions.EqualTo:
                return this.lc('EqualTo');
            case +EnumConditions.GreaterThan:
                return this.lc('GreaterThan');
            case +EnumConditions.GreaterThanOrEqualTo:
                return this.lc('GreaterThanOrEqualTo');
            case +EnumConditions.LessThan:
                return this.lc('LessThan');
            case +EnumConditions.LessThanOrEqualTo:
                return this.lc('LessThanOrEqualTo');
        }
    };
    ChooseAlarmModalComponent.prototype.formatDataType = function (dataType, bitIndexEnabled) {
        var _this = this;
        return this.dataTypeService.formatDataType(dataType, bitIndexEnabled, function (key) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return _this.lc.apply(_this, [key].concat(args));
        });
    };
    ChooseAlarmModalComponent.prototype.getRefAlarmsAndGroup = function () {
        this.getAlarmGroups();
        this.getRefAlarms();
    };
    ChooseAlarmModalComponent.prototype.getAlarmGroups = function () {
        var _this = this;
        this.fBoxAlarmRegistrationServiceProxy.getRefAlarmGroupNames(this.dataSourceId)
            .subscribe(function (result) {
            _this.groupNames = result;
        });
    };
    ChooseAlarmModalComponent.prototype.getRefAlarms = function (event) {
        var _this = this;
        if (!this.dataSourceId) {
            abp.notify.warn(this.lc('HaventSelectDataSource'));
            return;
        }
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            return;
        }
        this.primengTableHelper.showLoadingIndicator();
        this.fBoxAlarmRegistrationServiceProxy.getRefAlarmDefs(this.dataSourceId, this.refAlarmName, this.selectedGroupName, this.primengTableHelper.getSorting(this.dataTable), this.primengTableHelper.getMaxResultCount(this.paginator, event), this.primengTableHelper.getSkipCount(this.paginator, event))
            .pipe(finalize(function () { return _this.primengTableHelper.hideLoadingIndicator(); }))
            .subscribe(function (result) {
            _this.primengTableHelper.requestCompleted = true;
            _this.primengTableHelper.totalRecordsCount = result.totalCount;
            _this.primengTableHelper.records = result.items;
            _this.primengTableHelper.hideLoadingIndicator();
        });
    };
    __decorate([
        Input()
    ], ChooseAlarmModalComponent.prototype, "dataSourceId", void 0);
    __decorate([
        Output()
    ], ChooseAlarmModalComponent.prototype, "fBoxAlarmSelected", void 0);
    __decorate([
        ViewChild('dataTable', { static: true })
    ], ChooseAlarmModalComponent.prototype, "dataTable", void 0);
    __decorate([
        ViewChild('paginator', { static: false })
    ], ChooseAlarmModalComponent.prototype, "paginator", void 0);
    ChooseAlarmModalComponent = __decorate([
        Component({
            selector: 'choose-alarm-modal',
            template: "<div class=\"modal-content fe-modal-container\" bs-modal-drag> <div class=\"modal-header fe-modal-header\" style=\"border-bottom: 1px solid #f4f4f4;\"> <h4 class=\"fe-modal-header-title\"> <span>{{lc('ChooseSourceAlarm')}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\" style=\"padding: 1rem 1rem;\"> <div class=\"row search-condition\"> <div class=\"input-group col-md-4 col-xs-4\"> <input class=\"form-control var-form-control\" placeholder='{{lc(\"SearchAlarmName\")}}' type=\"text\" name=\"alarmName\" [(ngModel)]=\"refAlarmName\" (change)=\"getRefAlarms()\"> <span class=\"fa fa-search form-control-search\"></span> </div> <div class=\"input-group col-md-3 col-xs-3\"> <select class=\"form-control fc-Form\" style=\"padding: 0 1.25rem; height: 34px;\" name=\"groupName\" [(ngModel)]=\"selectedGroupName\" (change)=\"getRefAlarms()\"> <option [ngValue]=\"undefined\" selected>{{lc(\"AllGroup\")}}</option> <option *ngFor=\"let group of groupNames\" [value]=\"group.groupName\"> {{group.groupName}} </option> </select> </div> </div> <div class=\"primeng-datatable-container\" [busyIf]=\"primengTableHelper.isLoading\"> <p-table #dataTable (onLazyLoad)=\"getRefAlarms($event)\" [value]=\"primengTableHelper.records\" rows=\"{{primengTableHelper.defaultRecordsCountPerPage}}\" [paginator]=\"false\" [lazy]=\"true\" [scrollable]=\"true\" selectionMode=\"single\" [(selection)]=\"selectedFBoxAlarm\" ScrollWidth=\"100%\" [responsive]=\"primengTableHelper.isResponsive\"> <ng-template pTemplate=\"header\"> <tr> <th class=\"col-md-2 col-xs-2\"> {{lc('AlarmNameG')}} </th> <th class=\"col-md-2 col-xs-2\"> {{lc('AlarmMessage')}} </th> <th class=\"col-md-2 col-xs-2\"> {{lc('AlarmRule')}} </th> <th class=\"col-md-2 col-xs-2\"> {{lc('Devices')}} </th> <th class=\"col-md-2 col-xs-2\"> {{lc('DataType')}} </th> <th class=\"col-md-2 col-xs-2\"> {{lc('Address')}} </th> </tr> </ng-template> <ng-template pTemplate=\"body\" let-record> <tr [pSelectableRow]=\"record\"> <td> <div class=\"name-div\"> <p-tableRadioButton [value]=\"record\"></p-tableRadioButton> <span class=\"name-span\">{{record.name}}</span> </div> </td> <td> {{record.alarmMessage}} </td> <td> {{formatConditionType(record)}} </td> <td> {{record.devAlias}} </td> <td> {{formatDataType(record.dataType, record.bitIndexEnabled)}} </td> <td> {{record.addressDescription}} </td> </tr> </ng-template> </p-table> <div class=\"primeng-no-data\" *ngIf=\"primengTableHelper.totalRecordsCount == 0\"> {{l('NoData')}} </div> <div class=\"primeng-paging-container\"> <p-paginator [rows]=\"primengTableHelper.defaultRecordsCountPerPage\" #paginator (onPageChange)=\"getRefAlarms($event)\" [totalRecords]=\"primengTableHelper.totalRecordsCount\" [rowsPerPageOptions]=\"primengTableHelper.predefinedRecordsCountPerPage\"> </p-paginator> <span class=\"total-records-count\"> {{l('TotalRecordsCount', primengTableHelper.totalRecordsCount)}} </span> </div> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"saving || !selectedFBoxAlarm\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\" (click)=\"save()\"> {{lc('Confirm')}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l('Cancel')}} </button> </div> </div> </div> ",
            styles: [".search-condition { margin-bottom: 10px; .input-group { padding-right: 0; } } .input-group { .form-control { padding-right: 16px; } .var-form-control { height: 34px; padding: 0 2rem 0 1.25rem; } .form-control-search { position: absolute; z-index: 4; right: 10px; display: block; width: 16px; height: 16px; line-height: 34px; text-align: center; pointer-events: none; color: #aaa; } } select:invalid { color: gray !important; } option[disabled] { display: none !important; } option { color: black !important; } select option{ color: rgba(0,0,0,0.6); } .name-div { display: inline-flex; } .name-span { padding-left: 8px; word-break: break-all; } :host ::ng-deep .ui-radiobutton .ui-radiobutton-box{ .ui-radiobutton-icon { position: absolute !important; left: 50% !important; top: 50% !important; text-align: center; } } "]
        })
    ], ChooseAlarmModalComponent);
    return ChooseAlarmModalComponent;
}(ConfigureComponentBase));
export { ChooseAlarmModalComponent };
